import { useEffect, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';

export function isCollectEligibleBusiness(business) {
  if (!business) return false;
  if (business.isActive === false) return false;
  const status = String(business.status || '').toLowerCase();
  return (
    status === 'validated' ||
    status === 'approved' ||
    status === 'active' ||
    business.validated === true
  );
}

/**
 * Accès « Encaisser (QR) » réservé aux entrepreneurs
 * ayant au moins une entreprise validée (les admins restent autorisés).
 */
export function useCanCollectPayments() {
  const { currentUser, loading: authLoading, isAdmin } = useAuth();
  const [loading, setLoading] = useState(true);
  const [canCollect, setCanCollect] = useState(false);
  const [businesses, setBusinesses] = useState([]);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (authLoading) return;

      if (!currentUser) {
        if (!cancelled) {
          setCanCollect(false);
          setBusinesses([]);
          setLoading(false);
        }
        return;
      }

      if (typeof isAdmin === 'function' && isAdmin()) {
        if (!cancelled) {
          setCanCollect(true);
          setLoading(false);
        }
        return;
      }

      setLoading(true);
      try {
        const snap = await getDocs(
          query(collection(db, 'businesses'), where('userId', '==', currentUser.uid))
        );
        const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        const eligible = list.filter(isCollectEligibleBusiness);
        if (!cancelled) {
          setBusinesses(list);
          setCanCollect(eligible.length > 0);
        }
      } catch (err) {
        console.warn('[useCanCollectPayments]', err);
        if (!cancelled) {
          setCanCollect(false);
          setBusinesses([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [currentUser, authLoading, isAdmin]);

  return { canCollect, loading, businesses, currentUser };
}

export default useCanCollectPayments;
